<template>
  <div :id="bodyId"  :class="{ 'isLoading': isLoading }">
    <component :is="'style'">
    {{ css }}
    </component>

    <div v-for="(block, index) in blocks" :key="index">
      <div class="row py-5 mx-0" v-if="block === 'opportunities-list'">
        <div class="col-11 col-lg-9 mx-auto">
          <Jobs :key="$route.fullPath" />
        </div>
      </div>

      <div class="row py-5 mx-0" v-else-if="block === 'profile'">
        <div class="col-11 col-lg-9 mx-auto">
          <Profile />
        </div>
      </div>

      <div v-else v-html="block"></div>
    </div>
  </div>
</template>

<script>
import api from '@/data.json'
import Jobs from "@/components/builderComponents/Jobs.vue";
import Profile from "@/components/builderComponents/Profile.vue";

export default {
  name: "Page",

  data() {
    return {
      api: api,
      isLoading: false,
    }
  },

  computed: {
    page() {
      return api.pages.find((p) => p.slug == this.$route.name)
    },

    bodyId(){
      const htmlString = this.page['html'];
      const regex = /<body[^>]*id\s*=\s*["']([^"']*)["'][^>]*>/;
      const match = htmlString.match(regex);

      if (match && match[1]) {
        return match[1]
      } else {
        return null
      }
    },

    scripts(){
      const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
      let scripts = [];
      let match;
      
      while ((match = scriptRegex.exec(this.page['html'])) !== null) {
        scripts.push(match[1]);
      }
      
      return scripts;
    },

    css(){
      return this.page['css']
    },

    blocks(){
      return this.page['blocks']
    }
  },

  components: {
    Jobs,
    Profile
  },

  mounted(){
    eval(this.scripts[0])
  },
};
</script>

<style lang="scss" scoped>
  .isLoading{
    opacity: 0.7;
    pointer-events: none;
  }
</style>
